"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "rentals",
    path: "/rentals",
    component: "RentalBrowser"
});
let RentalBrowser = class RentalBrowser extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "RentalBrowser.dsParams");
    }
    getQueryParameters(...args) {
        if (this.dsParams.actives_only) {
            return { filter: 'inactive eq false' };
        }
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    dsParams;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('list_rental', { parameters: this.getQueryParameters });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'dsParams', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                dsParams: {
                    actives_only: true,
                },
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "inactive",
                        name: this.$fn.pgettext("Rentals", "Inactive"),
                        textAlign: "center",
                        formatter: {
                            name: "checkbox",
                        },
                    },
                    {
                        field: "name",
                        name: this.$fn.pgettext("Rentals", "Name"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("Rentals", "Description"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "categories",
                        name: this.$fn.pgettext("Rentals", "Category"),
                    },
                    {
                        field: "valid_from",
                        name: this.$fn.pgettext("Rentals", "Valid From"),
                        type: "date",
                    },
                    {
                        field: "valid_to",
                        name: this.$fn.pgettext("Rentals", "Valid To"),
                        type: "date",
                    },
                    {
                        field: "site_name",
                        name: this.$fn.pgettext("Rentals", "Site"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "property",
                            navigateOnIconClick: true,
                            params: {
                                id: "site_id",
                            },
                        },
                    },
                    {
                        field: "property_units",
                        name: this.$fn.pgettext("Rentals", "Property units"),
                        toolTip: this.$fn.pgettext("Rentals", "Property units"),
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            separator: ", ",
                            formatterContext: "item",
                            formatters: [{
                                    name: "getvalue",
                                    opts: {
                                        field: "code",
                                        source: "value",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "location_code",
                        name: this.$fn.pgettext("Rentals", "Location Code"),
                    },
                    {
                        field: "lot_number",
                        name: this.$fn.pgettext("Rentals", "Lot Number"),
                    },
                    {
                        field: "house_number",
                        name: this.$fn.pgettext("Rentals", "House Number"),
                    },
                    {
                        field: "area",
                        name: this.$fn.pgettext("Rentals", "Area"),
                        type: "text",
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("Rentals", "Company"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "current_tenant_name",
                        name: this.$fn.pgettext("Rentals", "Tenant"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "current_tenant_id",
                            },
                        },
                    },
                    {
                        field: "current_contract_number",
                        name: this.$fn.pgettext("Rentals", "Contract"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "contract",
                            navigateOnIconClick: true,
                            params: {
                                id: "current_contract_id",
                            },
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Rentals"),
                icon: this.$config.rental.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_4916_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_4918_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_4920_getActionArgs($event) {
        return {
            name: "CompanyModal",
            props: {
                id: $event.data.data.company_id,
            },
        };
    }
    async evh_2248226175642056_command_4919_getWhen($event) {
        return $event.data.column.id === 'company_name';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_showModal_4922_getActionArgs($event) {
        return {
            name: "CreateRental",
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_4916 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_4916_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_4915 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_4916,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_4915],
        });
        const act_2248226175642056_setData_4918 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_4918_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_4917 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_4918,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_4917],
        });
        const act_2248226175642056_showModal_4920 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_4920_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_4919 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_4920,
            event: "command",
            when: this.evh_2248226175642056_command_4919_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_4919],
        });
        const act_8320016629450276_showModal_4922 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_8320016629450276_showModal_4922_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_click_4921 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_showModal_4922,
            event: "click",
            displayName: "showModal",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_4921],
        });
        return {
            act_7315092382398562_closeModal_4916,
            evh_7315092382398562_close_4915,
            evh_7315092382398562_close,
            act_2248226175642056_setData_4918,
            evh_2248226175642056_selectedRowsChanged_4917,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_4920,
            evh_2248226175642056_command_4919,
            evh_2248226175642056_command,
            act_8320016629450276_showModal_4922,
            evh_8320016629450276_click_4921,
            evh_8320016629450276_click,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], RentalBrowser.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], RentalBrowser.prototype, "onSize", null);
RentalBrowser = __decorate([
    (0, vue_property_decorator_1.Component)()
], RentalBrowser);
exports.default = RentalBrowser;
vue_property_decorator_1.Vue.component("RentalBrowser", RentalBrowser);
